export default "__VITE_ASSET__21e542cd__"